<pr-content-container height="h-full" padding="p-0" overflow="overflow-hidden">
  <mat-progress-bar *ngIf="loading()" mode="indeterminate" />

  <div class="p-4">
    <mat-form-field class="w-full" subscriptSizing="dynamic">
      <mat-label>Search by Patient, Practice, Referrer, or Referral ID</mat-label>
      <input matInput [formControl]="searchControl" />
      @if (searchControl.value) {
        <button type="button" matSuffix mat-icon-button (click)="searchControl.reset()">
          <mat-icon>clear</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <table
    mat-table
    matSort
    matSortActive="patient"
    matSortDirection="asc"
    [dataSource]="table"
    [trackBy]="trackByRef"
  >
    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr
      *matRowDef="let record; columns: displayedColumns"
      mat-row
      class="cursor-pointer hover:bg-gray-100"
      (click)="viewReferral(record)"
    ></tr>

    <!-- Patient Column -->
    <ng-container matColumnDef="patient">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Patient
      </th>
      <td *matCellDef="let record" mat-cell>
        @if (record.patient; as patient) {
          {{ patient.name }}
        }
      </td>
    </ng-container>

    <!-- Practice Column -->
    <ng-container matColumnDef="practice">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Practice
      </th>
      <td *matCellDef="let record" mat-cell class="truncate">
        @if (record.practice) {
          {{ record.practice.name }}
        }
      </td>
    </ng-container>
    <!-- From Column -->
    <ng-container matColumnDef="referrer">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        From
      </th>
      <td *matCellDef="let record" mat-cell class="truncate">
        @if (record.referrer) {
          {{ record.referrer.name }}
        }
      </td>
    </ng-container>

    <!-- Urgency Column -->
    <ng-container matColumnDef="urgency">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Urgency
      </th>
      <td *matCellDef="let record" mat-cell class="truncate">
        @if (record.urgency) {
          {{ record.urgency | titlecase }}
        }
      </td>
    </ng-container>

    <!-- Referral ID Column -->
    <ng-container matColumnDef="uid">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Referral ID
      </th>
      <td *matCellDef="let record" mat-cell class="truncate">
        {{ record.uid }}
      </td>
    </ng-container>
  </table>

  @if (!loading() && table.filteredData.length === 0) {
    <pr-empty-state
      icon="folder_open"
      message="No referrals found"
      description="You have no referrals at this time"
    />
  }
</pr-content-container>
